import { differenceInWeeks, isBefore } from "date-fns";

import { Account } from "@/types/api";
import { convertStringToDate, isInTimeWindow } from "@/utils/date-utils";

import { ActivationStatus } from "../pages/ActivityDetails/types";

export enum UserStatus {
  ACCOUNT_CREATED = "Account Created",
  ACTIVE = "Active",
  MAINTENANCE = "Maintenance",
}

export function buildUserStatus(account: Account): string {
  const now = Date.now();
  const programStartOn = convertStringToDate(account.programStartOn);
  const programEndOn = convertStringToDate(account.programEndOn);

  // Neither value is set
  if (!programStartOn || !programEndOn) {
    return UserStatus.ACCOUNT_CREATED;
  }

  // If it is after the end of the program
  if (isBefore(programEndOn, now)) {
    return UserStatus.MAINTENANCE;
  }

  // Program start on is set, so display the weeks
  if (isBefore(programStartOn, now)) {
    return `Week ${differenceInWeeks(now, programStartOn)}`;
  }

  return UserStatus.ACCOUNT_CREATED;
}

// Used to convert @param deletedAt into activity or user status
export function convertActivationStatus(
  deletedAt?: string | null,
  startOn?: Date,
  endOn?: Date
): ActivationStatus {
  const isActive = !deletedAt && isInTimeWindow(new Date(), startOn, endOn);
  return isActive ? "Active" : "Deactivated";
}
